import api from '@pray/shared/utils/api';

type AutoSchedulePrayTvSlotParams = {
  artistId: string;
  publishedAt: string;
  sunsetAt: string;
};

// Admin-only (PB-38003): the backend picks one of the leader's public episodes
// (avoiding their 20 most recently scheduled ones) and books it into the window.
export async function autoSchedulePrayTvSlot({ artistId, publishedAt, sunsetAt }: AutoSchedulePrayTvSlotParams) {
  if (!artistId) throw Error('Artist ID is required');
  if (!publishedAt) throw Error('Published At is required');
  if (!sunsetAt) throw Error('Sunset At is required');

  const url = `/web/studio/artists/${artistId}/pray-tv-schedule/auto`;
  const response = await api.executePostRequest(url, {
    published_at: publishedAt,
    sunset_at: sunsetAt,
  });

  return response.data;
}
